import { MessageCircle } from "lucide-react";
import { FIRM } from "@/constants/firmInfo";

// WhatsApp click-to-chat — desktop only (mobile has WhatsApp built into the
// floating CTA bar). Many immigration/family law clients prefer chat over calling.
export const WhatsAppButton = () => {
  const digits = FIRM.phoneTel.replace(/[^0-9]/g, "");
  const message = encodeURIComponent(
    "Hi Rinnou & Associates, I'd like to ask about a legal matter."
  );

  return (
    <a
      href={`https://wa.me/${digits}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-chat-button"
      className="hidden lg:grid fixed z-50 right-6 bottom-6 h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_rgba(0,0,0,0.25)] place-items-center hover:scale-105 active:scale-95 transition-transform duration-200"
    >
      <MessageCircle className="h-7 w-7" strokeWidth={2} />
    </a>
  );
};
